import {useState, useEffect, useCallback} from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css'
import {base} from './components/Config/app'
import Home from './components/Home/Home'
import Header from './components/Home/Header'
import Footer from './components/Home/Footer'
import SignUp from './components/Sign/SignUp'
import { Salawaat } from './components/Salaat/Salaat'
import Landing from './components/Landing/Landing';
import {ProfileItems} from './components/Profile/Profile'
import { Services } from './components/Service/Services';
import {Read} from './components/Shared/Api';

function App() {
  const [etat, Etat]  = useState("")
  const [connected, Connect] = useState(false)
  const [account, Account] = useState({Service: base.name, connected:false, message:'', roles:'', Id:0, Role:0, Session:0, App:0, Name:'', Email:'', Phone:'', API_KEY:''})
  const [layout, Layout] = useState(window.matchMedia('(orientation:landscape)').matches)

  const [search, Search]  = useState("")
  const [plan, Plan] = useState("Free")
  const [lang, Lang] = useState("en")
  const [items, Items]= useState([])
  
  useEffect(() => {
    const store = localStorage.getItem(base.name)
    if(store) {
      //alert(`store=${JSON.stringify(store)}`)
      let infos = JSON.parse(store)
      if(infos.connected) {
        //console.info(infos); alert(`infos=${JSON.stringify(infos)}`)
        Connect(true)
        account.roles = infos.roles
        account.message = infos.message
        Account({...account, connected:true})

        Etat(infos.message)
        //console.info(account); alert(`infos=${JSON.stringify(account)}`)
      }
      else {
        Etat(`${infos.message??'Not Connected'} ?`)
      }
    }
  },[])

  useEffect(() => {
    if(connected) {
        //alert(`account connected=${JSON.stringify(account)}`)
        Read(`/member/Profile/1`, Items)
    }
  },[connected])

  const getProfile = (key) => {
    // alert(`infos=${JSON.stringify(account)}`)
    return items.find(item => item.Key === key)?.Value ?? ''
  }

  useEffect(()=>{ 
    if(items?.length>0) {
      // console.log(items); alert(items.length); alert(JSON.stringify(items))   
      Account({...account, Id:items[0].Id, Name:getProfile('Name'), Email:getProfile('Email'), API_KEY:getProfile('API_KEY') })
    }
  },[items])

  const onResize = useCallback(event => {
    let value=window.matchMedia('(orientation:landscape)').matches    
    Layout(value)
  }, [])

  useEffect(() => {
          window.addEventListener("resize", onResize);
          return () => {
              window.removeEventListener("resize", onResize);
          };
  }, [onResize, layout])

  return (
    
<BrowserRouter>
  <Header lang={lang} onLang={Lang} onSearch={Search} account={account} />
    <Routes className='App'>
      <Route path="/" element={<Landing lang={lang} connected={account.connected} service={base.service} />} />
        <Route path="/home" element={<Home lang={lang} account={account} />} />
        <Route path='/signup' element={<SignUp connected={account.connected} />} />
{ account.connected ?
<>
      <Route path="/service" element={<Services service={base.name} lang={lang} />} />
      <Route path='/setting' element={<ProfileItems lang={lang} account={account} onEtat={Etat} />} />
</>
: null }
      <Route path='/salaat' element={<Salawaat search={search} />} />
    </Routes>

  <Footer lang={lang} etat={etat} />
</BrowserRouter>

)

}

export default App;

